import {
  attr, belongsTo, hasMany,
} from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import DeliveryStatus from './DeliveryStatus';

const Delivery = ApplicationRecord.extend({
  attrs: {
    feedbacks: hasMany({ type: 'deliveries-feedbacks' }),
    delivery_address: belongsTo({ type: 'deliveries-delivery_addresses' }),
    courier_name: attr(),
    customer_id: attr(),
    delivery_address_id: attr(),
    delivery_date: attr(),
    delivery_instructions: attr(),
    delivery_option_id: attr({ type: Number }),
    portion_count_per_meal: attr(),
    promotional: attr(),
    recipient_email: attr(),
    recipient_name: attr(),
    recipient_phone: attr(),
    status: attr(),
    subscription_id: attr(),
    vip: attr(),
    one_off: attr(),
    billing_category: attr(),
    contents: attr(),
    contents_assigner: attr({ persist: false }),
    add_on_contents: attr(),
    product_contents: attr(),
    purchase_id: attr(),
    tracking_link: attr(),
    shipping_price: attr({ type: Number, persist: false }),
    created_at: attr({ persist: false }),
    updated_at: attr({ persist: false }),
  },
  static: {
    endpoint: '/deliveries',
    jsonapiType: 'deliveries-deliveries',
  },
  methods: {
    isCancellable() {
      return DeliveryStatus
        .cancellablePostBillingStatuses
        .includes(this.status);
    },
    type() {
      if (this.containsRecipes() && this.containsProducts()) return 'Both';
      if (this.containsRecipes()) return 'Recipes';
      if (this.containsProducts()) return 'Products';
      return "Empty";
    },
    containsRecipes() {
      return this.contents.length > 0;
    },
    containsProducts() {
      return this.product_contents.length > 0;
    }
  },
});

export default Delivery;
